import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './Medicamento.css'; // Puedes cambiar el nombre si es necesario

const tipoFormulario = "indice_homa";

const IndiceHoma = () => {
  const { idPaciente } = useParams();
  const navigate = useNavigate();
  const [indiceHoma, setIndiceHoma] = useState('');
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (idPaciente) {
      fetchFormularioExistente();
    }
  }, [idPaciente]);

  const fetchFormularioExistente = async () => {
    try {
      const res = await fetch(`https://api.weareinfinite.mx/form/formularios/${idPaciente}/${tipoFormulario}`);
      if (!res.ok) throw new Error('Formulario no encontrado');

      const data = await res.json();
      const respuestas = data.respuestas || [];

      const homa = respuestas.find(r => r.id === 'homa');
      if (homa) {
        setIndiceHoma(homa.respuesta);
        setEditMode(true);
      }
    } catch (error) {
      console.warn('No se encontró formulario previo:', error.message);
      setEditMode(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      idPaciente,
      tipoFormulario,
      respuestas: [
        {
          id: 'homa',
          respuesta: indiceHoma,
          comentario: ''
        }
      ]
    };

    try {
      const method = editMode ? 'PUT' : 'POST';
      const url = editMode
        ? `https://api.weareinfinite.mx/form/formularios/${idPaciente}/${tipoFormulario}`
        : `https://api.weareinfinite.mx/form/formularios`;

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const result = await response.json();
        throw new Error(result.mensaje || 'Error al guardar el índice de HOMA');
      }

      Swal.fire({
        icon: 'success',
        title: editMode ? 'Actualizado' : 'Guardado',
        text: 'Índice de HOMA guardado correctamente.',
        timer: 2000,
        showConfirmButton: false,
      });

      setIndiceHoma('');
      setEditMode(false);
    } catch (error) {
      console.error('Error al guardar:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Ocurrió un error al guardar el índice de HOMA.',
      });
    }
  };

  return (
    <div className="container">
      <h2>Índice de HOMA</h2>

      <form onSubmit={handleSubmit}>
        <label htmlFor="indiceHoma">Ingrese el índice de HOMA:</label>
        <input
          type="text"
          id="indiceHoma"
          value={indiceHoma}
          onChange={(e) => setIndiceHoma(e.target.value)}
          required
        />

        <div style={{ marginTop: '1rem' }}>
          <button type="submit">{editMode ? 'Actualizar' : 'Guardar'}</button>
          <button type="button" onClick={() => navigate(`/cronograma/${idPaciente}`)}>Regresar</button>
        </div>
      </form>
    </div>
  );
};

export default IndiceHoma;
